import { render, staticRenderFns } from "./About2.vue?vue&type=template&id=f652506e"
import script from "./About2.vue?vue&type=script&lang=js"
export * from "./About2.vue?vue&type=script&lang=js"
import style0 from "./About2.vue?vue&type=style&index=0&id=f652506e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports